import React, { useState, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { FiUsers, FiGlobe } from 'react-icons/fi';
import styled from 'styled-components';
import { PALE_WHITE_6, WHITE } from '../../appearance/Colors';

const ShareAndPublishModal = React.lazy(() => import('../Modals/ShareAndPublishModal'));

export function MessageSharingSummary({ status, detailed = false }) {
    const { t } = useTranslation();
    if (!status) return null;
    const people = status.shareCount === 1 ? t('folders:sharedWith1Person') : t('folders:sharedWithPeople', { value1: String(status.shareCount) });
    return <>
        {status.shareCount > 0 && <span title={people} aria-label={people}><FiUsers size={13} /><span>{detailed ? people : status.shareCount}</span></span>}
        {status.isPublished && <span title={t('folders:publishedLinkIsActive')} aria-label={t('folders:publishedLinkIsActive')}><FiGlobe size={13} />{detailed && <span>{t('folders:publishedLinkIsActive')}</span>}</span>}
    </>;
}

export default function MessageSharingIndicator({ message, disabled = false, onOpenChange }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const status = message?.sharingStatus;
    if (disabled || (!open && !(status?.shareCount > 0 || status?.isPublished))) return null;
    return <>
        <Indicator type="button" data-message-interactive="true" aria-label={t('common:shareAndPublish')}
            onClick={event => { event.stopPropagation(); setOpen(true); onOpenChange?.(true); }}>
            <MessageSharingSummary status={status} />
        </Indicator>
        {open && <Suspense fallback={null}><ShareAndPublishModal isOpen message={message} closeModal={() => { setOpen(false); onOpenChange?.(false); }} /></Suspense>}
    </>;
}

const Indicator = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 3px 6px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: ${PALE_WHITE_6};
    font: inherit;
    cursor: pointer;
    span { display: inline-flex; align-items: center; gap: 4px; }
    &:hover { color: ${WHITE}; background: rgba(255,255,255,.1); }
    &:focus-visible { outline: 2px solid ${WHITE}; }
`;
